import { connect } from 'react-redux'
import PupilsComponent from './pupils-filter-controls'
import { getSelectedGroupsArray } from '../pupils-component-redux/pupils-component.selectors'
import {
  showFilterDialog,
  resetFilter
} from '../pupils-component-redux/pupils-component.actions'

const mapStateToProps = state => ({
  selectedGroups: getSelectedGroupsArray(state)
})

const mapDispatchToProps = dispatch => ({
  onEdit: () => dispatch(showFilterDialog()),
  onSelectGroups: () => dispatch(showFilterDialog()),
  onReset: () => dispatch(resetFilter())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PupilsComponent)
